import { render, staticRenderFns } from "./InvoiceStats2.vue?vue&type=template&id=5a100270&"
import script from "./InvoiceStats2.vue?vue&type=script&lang=js&"
export * from "./InvoiceStats2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports